import React, { useState, useEffect } from 'react';
import { Button, Form, Image, Alert, ProgressBar, Badge, Modal, FormText, Accordion, Card, Row, Col, Container } from 'react-bootstrap';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { BrowserRouter as Router, Navigate, Outlet, Routes, Route, useNavigate } from "react-router-dom";
import { RenderHeader } from '../_components/Header';
import { NavbarSmart } from '../_components/NavbarSmart';


function Login() {

  // state
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false)
  const [errorMessage, setErrorMessage ] = useState(null)
  const handleKeyPress = e => {
    if (e.keyCode === 13) {
      console.log('ENTER')
      handleLogin()
    }
  }

  // function vars
  let navigate = useNavigate();

  async function handleLogin() {
    setIsLoggingIn(true);
    setErrorMessage(null);

    const submitItems = {
      email: email,
      password: password
    }

    axios.post(process.env.REACT_APP_BASE_URL + 'jobs/auth/login', submitItems)
           .then( (response) => {
              //  console.log(response.data);
               if (response.data.status === 'ok') {
                // write a cookie with the session key
                const cookies = new Cookies();
                cookies.set('t', response.data.authToken, {secure: true, sameSite: 'none'});
                cookies.set('e', response.data.email, {secure: true, sameSite: 'none'});
                cookies.set('jsp', 1, {secure: true, sameSite: 'none'});

                setIsLoggingIn(false);
                navigate('/dash', {replace: true});

               } else {
                  setErrorMessage("Invalid Username / Password")
                  setIsLoggingIn(false);
               }

            //    return response;
           })
         
        
    
  }

  return (
    <>
      <RenderHeader />
      <NavbarSmart />
      <Container>
        <Row>
          <Col>
            <br/>
            <Card style={{textAlign: "center"}}>
              <Card.Title><br/>Login</Card.Title>
              <Card.Body>
              Why do I make folks log in?  The short version is to keep bots and cralwers from scraping my jobs.  This site is always free <b>to people</b>.  Just not bots. :-)
                <br/>
                <br/>
                <Form>
                  {errorMessage ? <Alert variant="warning">{errorMessage}</Alert> : <div></div>} 
                  <Form.Group controlId="formBasicEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyPress={handleKeyPress}
                    />
                  </Form.Group>
                  <br/>
                  <Button variant="primary" onClick={handleLogin}>
                  {isLoggingIn ? 'Logging in...' : 'Login'}
                  </Button>
                </Form>
              </Card.Body>

            </Card>
          </Col>
        </Row>
      </Container>
  
    </>
  );
}

export default Login;